function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createPopper } from '@popperjs/core';

function computeHoverPadClipPath(_ref) {
  var placement = _ref.placement,
      reference = _ref.reference,
      popper = _ref.popper;

  if (placement === 'top') {
    return "polygon(\n      0 0,\n      100% 0,\n      ".concat(reference.left - popper.left + reference.width, "px 100%,\n      ").concat(reference.left - popper.left, "px 100%\n    )");
  }

  if (placement === 'top-start') {
    return "polygon(\n      0 0,\n      100% 0,\n      ".concat(reference.width, "px 100%,\n      0 100%\n    )");
  }

  if (placement === 'top-end') {
    return "polygon(\n      0 0,\n      100% 0,\n      100% 100%,\n      calc(100% - ".concat(reference.width, "px) 100%\n    )");
  }

  if (placement === 'bottom') {
    return "polygon(\n      100% 100%,\n      0 100%,\n      ".concat(reference.left - popper.left, "px 0,\n      ").concat(reference.left - popper.left + reference.width, "px 0\n    )");
  }

  if (placement === 'bottom-start') {
    return "polygon(\n      0 0,\n      ".concat(reference.width, "px 0,\n      100% 100%,\n      0 100%\n    )");
  }

  if (placement === 'bottom-end') {
    return "polygon(\n      calc(100% - ".concat(reference.width, "px) 0,\n      100% 0,\n      100% 100%,\n      0 100%\n    )");
  }

  if (placement === 'right') {
    return "polygon(\n      100% 0,\n      100% 100%,\n      0 ".concat(reference.top - popper.top + reference.height, "px,\n      0 ").concat(reference.top - popper.top, "px\n    )");
  }

  if (placement === 'right-start') {
    return "polygon(\n      0 0,\n      100% 0,\n      100% 100%,\n      0 ".concat(reference.height, "px\n    )");
  }

  if (placement === 'right-end') {
    return "polygon(\n      0 100%,\n      0 calc(100% - ".concat(reference.height, "px),\n      100% 0,\n      100% 100%\n    )");
  }

  if (placement === 'left') {
    return "polygon(\n      0 0,\n      0 100%,\n      100% ".concat(reference.top - popper.top + reference.height, "px,\n      100% ").concat(reference.top - popper.top, "px\n    )");
  }

  if (placement === 'left-start') {
    return "polygon(\n      0 0,\n      100% 0,\n      100% 100%,\n      0 ".concat(reference.height, "px\n    )");
  }

  if (placement === 'left-end') {
    return "polygon(\n      0 0,\n      100% calc(100% - ".concat(reference.height, "px),\n      100% 100%,\n      0 100%\n    )");
  }

  return null;
}
/**
 * The Anchored component renders some layered UI "anchored" to a specific element
 * in the DOM. The particular placement of the Anchored component can be modified using
 * props. This functionality is powered by Popper.js v2 and requires it be installed
 * and may require polyfills depending on browser support.
 *
 * ## Dependencies
 * - [Popper.js](https://popper.js.org/docs/v2/)
 * - [Popper.js required polyfills / browser support](https://popper.js.org/docs/v2/browser-support/)
 *
 * ## Related Components
 * - [Trigger](../Trigger/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <Anchored to={ref} >
 *   ... your UI here
 * </Anchored>
 *```
 *
 * ## Props
 */


var Anchored = /*#__PURE__*/function (_PureComponent) {
  _inherits(Anchored, _PureComponent);

  var _super = _createSuper(Anchored);

  _createClass(Anchored, null, [{
    key: "configure",
    value: function configure(config) {
      Anchored.config = _objectSpread(_objectSpread({}, Anchored.config), config);
    }
  }]);

  function Anchored(props) {
    var _this;

    _classCallCheck(this, Anchored);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      hoverPadRight: null,
      hoverPadLeft: null,
      hoverPadTop: null,
      hoverPadHeight: null,
      hoverPadWidth: null,
      clipPath: null,
      placement: null
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      var _this$props = _this.props,
          onMouseLeave = _this$props.onMouseLeave,
          hoverable = _this$props.hoverable;
      if (!hoverable) return;
      onMouseLeave();
    });

    _this.myRef = /*#__PURE__*/React.createRef();
    Anchored.count += 1;
    return _this;
  }

  _createClass(Anchored, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          to = _this$props2.to,
          placement = _this$props2.placement,
          shouldFollow = _this$props2.shouldFollow,
          hoverable = _this$props2.hoverable,
          offsetFrom = _this$props2.offsetFrom,
          offsetAlong = _this$props2.offsetAlong,
          hasArrow = _this$props2.hasArrow;
      this.popper = createPopper(to || document.body, this.myRef.current, {
        placement: placement,
        modifiers: [{
          name: 'offset',
          options: {
            offset: [offsetAlong, offsetFrom]
          }
        }, {
          name: 'arrow-position',
          enabled: !!hasArrow,
          phase: 'afterWrite',
          fn: function fn() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                finalPlacement = _ref2.state.placement;

            var reference = to.getBoundingClientRect();

            var popper = _this2.myRef.current.getBoundingClientRect();

            var paddingForCornerRadius = 20;
            var arrowXDiff = 0;
            var arrowYDiff = 0;

            if (/(bottom|top)/.test(finalPlacement)) {
              arrowXDiff = reference.x + reference.width / 2 - (popper.x + popper.width / 2);
            }

            if (/(left|right)/.test(finalPlacement)) {
              arrowYDiff = reference.y + reference.height / 2 - (popper.y + popper.height / 2);
            }
            /**
             * The arrow should disappear if it moves outside the bounds of the popper to avoid the
             * arrow floating in space separate from the popper element.
             */


            var hideArrow = Math.abs(arrowXDiff) >= popper.width / 2 - paddingForCornerRadius || Math.abs(arrowYDiff) >= popper.height / 2 - paddingForCornerRadius;

            _this2.setState({
              arrowXDiff: arrowXDiff,
              arrowYDiff: arrowYDiff,
              hideArrow: hideArrow
            });
          }
        },
        /**
         * This modifier is in charge of creating the hover pads shape and positioning
         * it correctly. The logic / math below can probably be greatly simplified.
         * It will create a rectangle and clip it to the correct shape to allow for
         * desire paths for mouse users
         */
        {
          name: 'calculateHoverPad',
          enabled: true,
          phase: 'afterWrite',
          fn: function fn(_ref3) {
            var state = _ref3.state;

            _this2.setState({
              placement: state.placement
            });

            if (_this2.previousPlacement === state.placement) return;
            if (!hoverable) return;
            _this2.previousPlacement = state.placement;
            var reference = to.getBoundingClientRect();

            var popper = _this2.myRef.current.getBoundingClientRect();

            var hoverPadHeight = reference.height + offsetFrom;
            var hoverPadWidth = popper.width;
            var hoverPadTop = 0;
            var hoverPadLeft = reference.left - popper.left;
            var hoverPadRight = null;

            if (/^(bottom|top)/.test(state.placement)) {
              hoverPadLeft = 0;
              hoverPadTop = /^(bottom)/.test(state.placement) ? -reference.height - offsetFrom : popper.height;
            } else {
              hoverPadWidth = reference.width + offsetFrom;
              hoverPadHeight = popper.height;
            } // Switches to right based position when anchored element is positioned to the
            // left to account for border widths


            if (/^left/.test(state.placement)) {
              hoverPadLeft = null;
              hoverPadRight = popper.right - reference.right;
            }

            var clipPath = computeHoverPadClipPath({
              placement: state.placement,
              reference: reference,
              popper: popper
            });

            _this2.setState({
              placement: state.placement,
              hoverPadLeft: hoverPadLeft,
              hoverPadTop: hoverPadTop,
              hoverPadHeight: hoverPadHeight,
              hoverPadWidth: hoverPadWidth,
              hoverPadRight: hoverPadRight,
              clipPath: clipPath
            });
          }
        }]
      });

      if (shouldFollow) {
        this.followAnchor();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var popper = this.popper;
      popper.destroy();
      cancelAnimationFrame(this.timerId);
    }
  }, {
    key: "followAnchor",
    value: function followAnchor() {
      var _this3 = this;

      this.timerId = requestAnimationFrame(function () {
        var popper = _this3.popper;
        popper.update();

        _this3.followAnchor();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isSsr = Anchored.config.isSsr;
      var _this$props3 = this.props,
          className = _this$props3.className,
          _this$props3$to = _this$props3.to,
          to = _this$props3$to === void 0 ? !isSsr && document.body : _this$props3$to,
          children = _this$props3.children,
          hoverable = _this$props3.hoverable,
          debug = _this$props3.debug;
      var _this$state = this.state,
          hoverPadRight = _this$state.hoverPadRight,
          hoverPadLeft = _this$state.hoverPadLeft,
          hoverPadTop = _this$state.hoverPadTop,
          hoverPadHeight = _this$state.hoverPadHeight,
          hoverPadWidth = _this$state.hoverPadWidth,
          clipPath = _this$state.clipPath,
          placement = _this$state.placement,
          arrowXDiff = _this$state.arrowXDiff,
          arrowYDiff = _this$state.arrowYDiff,
          hideArrow = _this$state.hideArrow;
      var anchorElDims = {};

      if (!isSsr) {
        anchorElDims = to.getBoundingClientRect();
      }

      var _anchorElDims = anchorElDims,
          width = _anchorElDims.width,
          height = _anchorElDims.height;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.myRef,
        className: className,
        style: {
          pointerEvents: 'auto'
        },
        onMouseLeave: this.onMouseLeave
      }, typeof children === 'function' ? children({
        placement: placement,
        arrowXDiff: arrowXDiff,
        arrowYDiff: arrowYDiff,
        hideArrow: hideArrow
      }) : children, hoverable && /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: debug ? 'rgba(255, 0, 0, 0.5)' : null,
          position: 'absolute',
          width: hoverPadWidth || width,
          height: hoverPadHeight || height,
          top: hoverPadTop,
          right: hoverPadRight,
          left: hoverPadLeft,
          clipPath: clipPath
        }
      }));
    }
  }]);

  return Anchored;
}(PureComponent);

_defineProperty(Anchored, "count", 0);

_defineProperty(Anchored, "config", {
  isSsr: false
});

Anchored.defaultProps = {
  className: '',
  to: undefined,
  onMouseLeave: function onMouseLeave() {},
  children: null,
  hoverable: false,
  placement: 'bottom-start',
  shouldFollow: false,
  debug: false,
  offsetAlong: 0,
  offsetFrom: 0,
  hasArrow: false
};
Anchored.propTypes = {
  /**
   * Whether to compute the position adjustment for the tooltip arrow element
   */
  hasArrow: PropTypes.bool,

  /**
   * Places the component in debug mode
   */
  debug: PropTypes.bool,

  /**
   * Allows adding a custom class or series of classes on the component
   */
  className: PropTypes.string,

  /**
   * Element / ref to anchor to
   *
   * TODO: define what Element APIs are required, PropTypes.instanceOf(Element)
   * causes issues in the SSR context :(
   */
  to: PropTypes.shape({}),

  /**
   * event callback to be called when user mouses off of rendered UI
   */
  onMouseLeave: PropTypes.func,

  /**
   * Whether to allow hovering trigger / close behavior
   */
  hoverable: PropTypes.bool,

  /**
   * The UI component to anchor
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Where in relation to the anchor the rendered UI should be placed. See Popper.js
   * for all possible placements
   */
  placement: PropTypes.oneOf(['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left', 'left-start', 'left-end']),

  /**
   * Whether or not the anchored UI should follow the anchor. This is needed for elements
   * that animate
   */
  shouldFollow: PropTypes.bool,

  /**
   * The amount of offset to apply parallel to the reference element. For left / right placement
   * this is along the y-axis and top / bottom is the x-axis. Negative values are accepted and
   * will move the anchored component in the opposite direction
   */
  offsetAlong: PropTypes.number,

  /**
   * The amount of offset to apply perpendicular to the reference element. For left / right
   * placement this is along the x-axis and top / bottom is the y-axis. Negative values are
   * accepted and will move the anchored component in the opposite direction
   */
  offsetFrom: PropTypes.number
};
export default Anchored;